import HRCreateJob from "src/components/skill/hr/CreateSkill";

export default function CreateSkill() {
  return (
    <div className='w-11/12 max-w-7xl mx-auto'>
      <HRCreateJob />
    </div>
  );
}
